import { apiCallCenter } from '@/plugins/axios'
import { hostname } from '@/utils/hostname'


export default {
  getRelatorioResumidoDiretoOperadorTotal(data) {
    return apiCallCenter().post('/relatorios/operadores/direto/resumido/total?_method=GET', data)
  },
  getRelatorioResumidoDiretoOperadorDiaCorrido(data) {
    return apiCallCenter().post('/relatorios/operadores/direto/resumido/dia-corrido?_method=GET', data)
  },
  getRelatorioResumidoDiretoOperadorMediaDia(data) {
    return apiCallCenter().post('/relatorios/operadores/direto/resumido/media-dia?_method=GET', data)
  },
  getRelatorioResumidoDiretoOperadorHora(data) {
    return apiCallCenter().post('/relatorios/operadores/direto/resumido/hora?_method=GET', data)
  },
  getRelatorioResumidoDiretoOperadorMediaHora(data) {
    return apiCallCenter().post('/relatorios/operadores/direto/resumido/media-hora?_method=GET', data)
  },

  exportExcel(params) {
    let query = new URLSearchParams(params.dateTimeRange).toString();

    if(params.operadores.length == 0){
      query = `${query}&operadores[]=${params.operadores}`
    }else{
      params.operadores.forEach(operador => {
        query = `${query}&operadores[]=${operador}`
      })
    }
    if(params.centrosDeCusto.length == 0){
      query = `${query}&centrosDeCusto[]=${params.centrosDeCusto}`
    }else{
      params.centrosDeCusto.forEach(centrosDeCusto => {
        query = `${query}&centrosDeCusto[]=${centrosDeCusto}`
      })
    }
    if(params.maiorQue != 0){
      query = `${query}&maiorQue=${params.maiorQue}`
    }else{
      query = `${query}&maiorQue=0`
    }
    const token = window.localStorage.getItem('pcm_access_token')
    query = `${query}&token=${token}`
    return `https://${hostname()}/backend/callcenter/relatorios/operadores/direto/export?${query}`
  },
}
